import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLanguage } from "@/context/LanguageContext";
import { joinWaitlist } from "@/lib/api";

export default function WaitlistModal({ open, onOpenChange }) {
  const { t, logoMark } = useLanguage();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [joining, setJoining] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setJoining(true);
    try {
      const { data } = await joinWaitlist({ name, email, website });
      toast.success(data.status === "exists" ? t.waitlist.exists : t.waitlist.success);
      setName("");
      setEmail("");
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.status === 429 ? t.common.rateLimited : t.waitlist.error);
    } finally {
      setJoining(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-lime-500 transition-[box-shadow,border-color]";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="waitlist-modal" className="rounded-3xl sm:max-w-md">
        <DialogHeader>
          <span className="w-14 h-14 rounded-2xl bg-lime-50 flex items-center justify-center mb-2">
            <img src={logoMark} alt="" className="h-10 w-auto" />
          </span>
          <DialogTitle className="font-display text-xl sm:text-2xl font-bold text-slate-900">{t.waitlist.title}</DialogTitle>
          <DialogDescription className="text-sm sm:text-base text-slate-500">{t.waitlist.desc}</DialogDescription>
        </DialogHeader>
        <form data-testid="waitlist-form" onSubmit={onSubmit} className="space-y-4 mt-2">
          <input type="text" name="website" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" data-testid="waitlist-honeypot" />
          <input data-testid="waitlist-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder={t.waitlist.namePh} className={inputCls} />
          <input data-testid="waitlist-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t.waitlist.emailPh} className={inputCls} dir="ltr" />
          <button
            data-testid="waitlist-submit-button"
            type="submit"
            disabled={joining}
            className="w-full px-6 py-3.5 rounded-full bg-lime-500 text-slate-900 font-bold text-sm hover:bg-lime-400 disabled:opacity-60 transition-colors"
          >
            {joining ? t.waitlist.joining : t.waitlist.submit}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
